import { rgba } from 'polished';
export const getActiveTheme = (theme, menuThemeType) => {
    const themes = {
        primary: {
            default: {
                backgroundColor: rgba('#000', 0),
                // TODO: why text color
                color: theme.color.textColor0,
            },
            selected: {
                backgroundColor: theme.color.primary,
                color: theme.color.primaryTextColor,
            },
            unSelected: {
                backgroundColor: rgba('#000', 0),
                color: theme.color.textColor0,
            },
            hover: {
                backgroundColor: theme.color.primary,
                color: theme.color.primaryTextColor,
            },
            unHover: {
                backgroundColor: rgba('#000', 0),
                color: theme.color.textColor0,
            },
        },
        dark: {
            default: {
                backgroundColor: rgba('#000', 0),
                color: theme.color.textColor2,
            },
            selected: {
                backgroundColor: theme.color.bgColor1,
                color: theme.color.primaryTextColor,
            },
            unSelected: {
                backgroundColor: rgba('#000', 0),
                color: theme.color.textColor2,
            },
            hover: {
                backgroundColor: theme.color.bgColor1,
                color: theme.color.primaryTextColor,
            },
            unHover: {
                backgroundColor: rgba('#000', 0),
                color: theme.color.textColor2,
            },
        },
        bgless: {
            default: {
                color: theme.color.textColor2,
            },
            selected: {
                color: theme.color.primaryTextColor,
            },
            unSelected: {
                color: theme.color.textColor2,
            },
            hover: {
                color: theme.color.primaryTextColor,
            },
            unHover: {
                color: theme.color.textColor2,
            },
        },
    };
    return themes[menuThemeType];
};
